import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const WidgetTimer: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        style={customStyle}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 6a8 8 0 110 16 8 8 0 010-16zm0 0V2m-2 0h4m2 4l1.5-1.5M12 10v4l2.5 1.5" />
      </svg>
    </div>
  );
};

export default WidgetTimer;
